/**
 * 서식 있는 본문 편집기 — **늦게 불러오는 껍데기** (v2.124.0)
 *
 * 편집기 본체(`RichEditorImpl.tsx` · TipTap/ProseMirror ≈ 0.4MB)는 메일 창·회의록 창을 열 때만
 * 필요하다. 메인 번들에 넣으면 PWA 미리 저장 한도(2MB)를 넘어 **빌드가 멈춘다**(2026-09-04 실측 2.29MB).
 * 그래서 여기서 `lazy()` 로 갈라 별도 덩어리로 내려받게 한다 — 첫 화면은 예전만큼 가볍다.
 */

import { Suspense, lazy } from 'react';
import type { RichEditorProps } from './RichEditorImpl';

const Impl = lazy(() => import('./RichEditorImpl').then((m) => ({ default: m.RichEditor })));

export function RichEditor(props: RichEditorProps) {
  return (
    <Suspense
      fallback={
        <div
          style={{
            minHeight: (props.minHeight ?? 160) + 40,
            border: '1px solid #cbd5e1',
            borderRadius: 4,
            background: '#f8fafc',
            color: '#94a3b8',
            fontSize: 12,
            padding: '8px 10px',
          }}
        >
          편집기를 불러오는 중…
        </div>
      }
    >
      <Impl {...props} />
    </Suspense>
  );
}

export type { RichEditorProps };
